<template>
  <div class="se-die-card">
    <div v-if="this.b1 != 0" style="text-align:center;margin-top:8px;">
      <img
        class="result-button"
        :src="require(`../../../assets/images/se-die/${this.b1}.png`)"
        width="10%"
        alt
      />
      <img
        class="result-button"
        :src="require(`../../../assets/images/se-die/${this.b2}.png`)"
        width="10%"
        alt
      />
      <img
        class="result-button"
        :src="require(`../../../assets/images/se-die/${this.b3}.png`)"
        width="10%"
        alt
      />
      <img
        class="result-button"
        :src="require(`../../../assets/images/se-die/${this.b4}.png`)"
        width="10%"
        alt
      />
    </div>
  </div>
</template>

<script>
import { Row, Col, Button } from "iview";
import betLotMixin from "../../../mixins/bet-lot-mixin";
import EventBus from "../../../configs/event-bus";

export default {
  mixins: [betLotMixin],
  props: [
    "game",
    "winCellNo",
    "secondsString",
    "minutesString",
    "gameData",
    "showDrawingAnimation",
    "drawResult",
  ],
  components: {
    Row,
    Col,
    Button,
  },
  data() {
    return {
      b1: "",
      b2: "",
      b3: "",
      b4: "",
      counter: 0,
    };
  },
  watch: {
    drawResult(newVal, oldVal) {
      //   console.log(this.drawResult);
      let temp = this.drawResult.draw_result.split(",");
      this.b1 = temp[0];
      this.b2 = temp[1];
      this.b3 = temp[2];
      this.b4 = temp[3];
      if (newVal) {
        let vm = this;
        if (this.counter > 0) {
          // clearStakeRecord(vm.gameData.gID);
          // EventBus.$emit("update-session-storage");
          // this.animationEnd();
        }
        this.counter++;
      }
    },
  },
  mounted() {},

  methods: {
    // animationEnd() {
    //   this.$emit("on-animation-end");
    // },
  },
};
</script>

<style lang="scss" scoped>
.se-die-card {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 52px;
  width: 100%;
  background: #182841;
  background: -moz-linear-gradient(top, #182841 0%, #0a1527 100%);
  background: -webkit-linear-gradient(top, #182841 0%, #0a1527 100%);
  background: linear-gradient(to bottom, #182841 0%, #0a1527 100%);
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#182841', endColorstr='#0a1527',GradientType=0 );
}
</style>
